export const getUserInfo = (state = {value: 0}, action) => {
    switch(action.type) {
        case "change1":
            return {
                value: action.payload
            }
        default:
            return state;
    }
}